import React, { useEffect } from 'react';

import { useTagState, useTagActions } from './TagContext';

import Button from '../../Shared/UI/Button/components/Button';

import { addToGlobalDenyList } from './restApi';

const AddToGlobalDenyListButton = () => {
  const state = useTagState();
  const { onResponse, onError } = useTagActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  useEffect(() => {
    if (state?.deleted) {
      window.location.assign(`/tags/`);
    }
  }, [state?.deleted]);

  return (
    <Button
      onClick={() => {
        addToGlobalDenyList({
          onResponse,
          onError,
          body: {
            authenticityToken,
            tagId: state?.tag?.id,
          },
        });
      }}
    >
      Add To Global Deny List
    </Button>
  );
};

export default AddToGlobalDenyListButton;
